import { createContext, useReducer } from "react";

type Action = { type: string; payload: any };

type UserType = {
  user: any;
  dispatchUser: (action: Action) => void;
};

const initalState: UserType = {
  user: null,
  dispatchUser: () => {},
};

export const UserContext = createContext<UserType>(initalState);

type Props = {
  children: React.ReactNode;
};

const reducerUser = (state: UserType, action: Action) => {
  switch (action.type) {
    case "set":
      return action.payload;
    case "reset":
      return initalState.user;
    default:
      return state;
  }
};

export function UserProvider({ children }: Props) {
  const [user, dispatchUser] = useReducer(reducerUser, initalState.user);

  return (
    <UserContext.Provider value={{ user, dispatchUser }}>
      {children}
    </UserContext.Provider>
  );
}
